import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import ComponentCategorySave from "./ComponentCategorySave";

const ComponentCategoryNew = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    const handleFormSubmit = (e) => {

        let componentcategoryid = "";

        let valid = true;

        let categoryname = "";
        if (document.getElementById("categoryname").value != "") {
            categoryname = document.getElementById("categoryname").value;
        }
        else {
            valid = false; 
            toast.error("Category Name required");
        }

        let categorydescription = "";
        if (document.getElementById("categorydescription").value != "") {
            
            categorydescription = document.getElementById("categorydescription").value;
        }
        else {
            valid = false; 
            toast.error("Category Name required");
        }

        let modifiedbyid = user["id"];
        let deleted = "0";

        if (valid) {
            ComponentCategorySave(componentcategoryid, categoryname, categorydescription, modifiedbyid, deleted);
            toast.success('Success');
            navigate("/ComponentCategory");
        }
    };

    document.title = "Customers - New";
    return ( 
        <div className="componentCategoryNew">

            {user["email"] != undefined &&
                <>
                    <div className="container body-content" style={{marginTop: "25px"}}>
                            
                    <h2>New Component Category</h2>

                        <form id="componentCategoryForm" noValidate="novalidate" autoComplete="off">    

                            <div className="form-group">
                                <label for="categoryname">Category Name</label>
                                <input className="form-control" id="categoryname" name="categoryname" type="text" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label for="categorydescription">Category Description</label>
                                <input className="form-control" id="categorydescription" name="categorydescription" type="text" autoComplete="off" />
                            </div>

                        </form>
                        <Link to="/ComponentCategory" className="btn btn-default" style={{marginRight: "4px"}}>Cancel</Link>
                        <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>                        
                    </div>
                </>
            }
        </div>
     );
}
 
export default ComponentCategoryNew;
